<template>
    <div></div>
</template>
<script>
import commonAPI from "../../../utils/common";
export default {
    name: 'blankTest',
    components: {

    },
    data(){
        return {
            userInfo: '',
        }
    },
    created() {
        this.userInfo = commonAPI.getJsonLocal('appraiseNewLocalauthority');
        let obj = {
            area: this.getQueryVariable('area'),
            // areaName: this.getQueryVariable('areaName'),
            year: this.getQueryVariable('year'),
            quarter: this.getQueryVariable('quarter'),
            type: this.getQueryVariable('type'),
            id: this.getQueryVariable('id'),
            messageType: this.getQueryVariable('messageType'),
            complainNumber: this.getQueryVariable('complainNumber'),
            mainComplainNumber: this.getQueryVariable('mainComplainNumber'),
        } ;

        /**  消息类型，如：5, 考核实时扣分
         * 1,3,4 取用户信息中的地区编码 和 名称；  只有 1,3,4 需要修改取用户的 area，areaName
         * 2、5 取 disposeUrl 中的地区编码 和 名称；
         * **/
        switch (obj.messageType) {
            case '1':
            case '3':
            case '4':
                obj.area = this.userInfo.area;
                // obj.areaName = this.userInfo.areaName;
                break;
            default:
        }
        this.toCorrespondingPage(obj);
    },
    methods: {
        /**
         * @description: [通过参数名获取url中的参数值]
         * 示例 URL: assessItem/beCriticizedBySuperiorsCity?area=530100&areaName=昆明市&areaType=1&type=收到上级通报批评&punishType=E1
         * @param { val } string 参数名
         * @return: {string} string 参数值
         */
        getQueryVariable(val){
            const url = window.location.href;
            const query = url.substring(url.lastIndexOf("?") + 1);
            const vars = query.split("&");
            for (let i = 0; i < vars.length; i++) {
                    let pair = vars[i].split("=");
                    if(pair[0] == val){
                        return decodeURI(pair[1]);
                    }
            }
            return false;
        },
        toCorrespondingPage(obj) {
            const {
                area,
                // areaName,
                year,
                quarter,
                type,
                id,
                complainNumber,
                mainComplainNumber,
            } = obj;

            // 跳转到首页 数据可视化
            if (type == 'main' && this.userInfo.areaLevel === '1') {
                this.$router.replace({
                    path: '/appraise/index',
                    //path: '/appraise/index',
                });
            } else if (type == 'main' && this.userInfo.areaLevel === '2') {
                this.$router.replace({
                    path: '/appraise/detail',
                    year: year,
                    quarter: quarter,
                    area: area,
                });
            }

            // 跳转到 综合调度指挥中心建立情况、综合调度指挥中心运行情况、州市涉旅案件查处情况
            if ( type == 'A1' || type == 'A2' || type == 'A3') {
                this.$router.replace({
                    path: '/appraise/deduction_detail',
                    query: {
                        monitorType: type,
                        year: year,
                        quarter: quarter,
                        area: area,
                    }
                });
            }

            // 跳转到 投诉5分钟内未响应情况
            if ( type == 'B1') {
                this.$router.replace({
                    path: '/appraise/fiveMunites',
                    query: {
                        orderSubNo: complainNumber,
                        orderNo: mainComplainNumber,
                        quarter,
                        year
                    }
                });
            }

            // 跳转到 投诉超过24小时未办结情况
            if ( type == 'B2') {
                this.$router.replace({
                    path: '/appraise/twentyFourHours',
                    query: {
                        orderSubNo: complainNumber,
                        orderNo: mainComplainNumber,
                        quarter,
                        year
                    }
                });
            }

            // 跳转到 诚信评价基础工作考评、诚信评价完成率考评、诚信评价质量考评、诚信评价结果运用考评
            if ( type == 'C1' || type == 'C2' || type == 'C3' || type == 'C4') {
                this.$router.replace({
                    path: '/appraise/creditDetail',
                    query: {
                        integrityType: type,
                        year: year,
                        quarter: quarter,
                        area: area,
                    }
                });
            }

            // 跳转到 涉旅安全事故发生情况
            if ( type == 'accident' ) {
                this.$router.replace({
                    path: '/appraise/deductDetail',
                    query: {
                        area: area,
                        id: id,
                        year: year,
                        quarter: quarter,
                    }
                });
            }

            // 受到上级通报批评、约谈、问责等处理情况
            if ( type == 'E1' || type == 'E2' || type == 'E3' ) {
                this.$router.replace({
                    path: '/appraise/deductDetailNotifi',
                    query: {
                        area: area,
                        id: id,
                        year: year,
                        quarter: quarter,
                    }
                });
            }

            // 跳转到 发生涉旅负面舆情情况
            if ( type == 'badOpinion' ) {
                this.$router.replace({
                    path: '/appraise/deductDetailNegative',
                    query: {
                        area: area,
                        id: id,
                        year: year,
                        quarter: quarter,
                    }
                });
            }

            // 跳转到 游客体验满意度
            if ( type == 'exp' ) {
                this.$router.replace({
                    path: '/appraise/touristExperience',
                    query: {
                        area: area,
                        year: year,
                        quarter: quarter,
                    }
                });
            }

        }
    }
}
</script>
<style scoped>

</style>
